import SingleSelectComponent from "../../../../components/SingleSelect";


/**
 * Renders a question asking the user whether they have a compatible BP cuff.
 * 
 * @param show_bp_cuff_question - Whether the question should be displayed.
 * @param provide_bp_cuff_option - If true, show the option to send a monitor.
 * @param bp_cuff_require_bluetooth_option - If true, hide the manual option.
 * @param bpCuffValue - Current selected value.
 * @param setBpCuffValue - Callback to update selected value.
 * @param validBpCuff - Boolean indicating if the current selection is valid.
 * @returns JSX.Element or null
 */
function renderBPcuffQuestion(
    show_bp_cuff_question: boolean,
    provide_bp_cuff_option: boolean,
    bp_cuff_require_bluetooth_option: boolean,
    bpCuffValue: string,
    setBpCuffValue: (val: string) => void,
    validBpCuff: boolean
): JSX.Element | null {
    const bpCuffOptions = [
        { value: 'Omron', label: 'Yes, I will use my Omron monitor', show: true },
        { value: 'iHealth', label: 'Yes, I will use my iHealth monitor', show: true },
        {
            value: 'No',
            label: 'No, please send me a blood pressure monitor',
            show: provide_bp_cuff_option
        },
        {
            value: 'Manual',
            label: 'No, but I will use another blood pressure monitor and self-report my readings',
            show: !bp_cuff_require_bluetooth_option
        }
    ]
    const bpCuffQuestion: JSX.Element = <SingleSelectComponent
        question="Do you have a Bluetooth-enabled Omron or iHealth blood pressure monitor that you will use for the program?"
        options={bpCuffOptions}
        value={bpCuffValue}
        onChange={setBpCuffValue}
        showMessage={!validBpCuff}
    />;
    if (show_bp_cuff_question) {
        return bpCuffQuestion
    } else {
        return null;
    }
}

export default renderBPcuffQuestion;
